import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import JoinInMinutesBanner from '../../assets/images/joinInMinutes.jpg';
import RoutePaths from '../../configs/Routes';

const JoinInMinutes = () => (
  <Box my={6} px={{ xs: 2, sm: 6, md: 10, lg: 30 }} mt={-3}>
    <Box
      sx={{
        position: 'relative',
        borderRadius: '40px',
        overflow: 'hidden',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${JoinInMinutesBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
        }}
      />

      {/* Black Transparent Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 1,
        }}
      />

      {/* Content Layer */}
      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
        position="relative"
        zIndex={2}
        px={{ xs: 3, md: 8 }}
        py={{ xs: 4, md: 6 }}
      >
        {/* Text */}
        <Grid item xs={12} md={7}>
          <Typography
            fontFamily='"Archivo Black", sans-serif'
            fontWeight="900"
            variant="h4"
            color="#FFFFFF"
            gutterBottom
            textAlign={{ xs: 'center', md: 'left' }}
          >
            Join in Minutes. <br />
            Start Earning Today.
          </Typography>
          <Typography
            variant="subtitle1"
            color="#FF6B00"
            fontWeight="500"
            lineHeight="130%"
            letterSpacing="0"
            fontFamily="Lato"
            fontSize={{ xs: '1rem', md: '1.25rem' }}
            textAlign={{ xs: 'center', md: 'left' }}
            pt={1}
            pb={2}
          >
            Your network is your power — let&apos;s turn it into income.
          </Typography>
        </Grid>

        {/* Button */}
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          justifyContent={{ xs: 'center', md: 'flex-end' }}
          alignItems="center"
        >
          <Button
            variant="contained"
            disableElevation
            sx={{
              px: 6,
              py: 2,
              fontSize: { xs: '1rem', md: '1.1rem' },
              backgroundColor: '#FF6B00',
              borderRadius: '100px',
              fontFamily: 'Lato',
              color: 'white',
              fontWeight: 700,
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
            LinkComponent={Link}
            to={RoutePaths.SIGN_UP}
          >
            Sign Up Free
          </Button>
        </Grid>
      </Grid>
    </Box>
  </Box>
);

export default JoinInMinutes;
